import React, { ReactNode } from 'react';
import { useStyles } from './Layout.styles';
import { Navigation } from './Navigation/Navigation';
import { Content } from './Content/Content';

interface Props {
  children: ReactNode;
}

export function Layout({ children }: Props) {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Navigation />
      <Content>{children}</Content>
    </div>
  );
}
